import request from "@acri-tools/react-tools/utils/request"
import { API_URL } from "./config"

export const keycloak_logout = () =>{
    let url = `${API_URL}/api/keycloak/logout`;
    let a = document.createElement('a');
    a.href = url;
    a.click();
}